// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-progress-bar {
  position: relative;
  margin: 15px 0;
}
@keyframes animate-stripes {
  100% {
    background-position: -100px 0;
  }
}
.custom-progress-bar p {
  color: var(--sebrae-blue);
  font-family: var(--font-lato);
  font-size: 13px;
  font-weight: 400;
  line-height: 1;
  max-width: 100%;
}
.custom-progress-bar progress[value] {
  appearance: none;
  border: none;
  width: 100%;
  height: 8px;
  background-color: #E2E6E8;
  border-radius: 4px;
  box-shadow: none;
  color: var(--sebrae-blue);
  position: relative;
}
.custom-progress-bar progress[value]::-webkit-progress-bar {
  background-color: #E2E6E8;
  border-radius: 4px;
  box-shadow: none;
}
.custom-progress-bar progress[value]::-webkit-progress-value {
  position: relative;
  background-size: 100%;
  border-radius: 3px;
  background-image: -webkit-linear-gradient(45deg, #3b4aff 0%, #40bbff 100%);
  animation: animate-stripes 5s linear infinite;
}
.custom-progress-bar progress[value]::-webkit-progress-value:after {
  content: "";
  position: absolute;
  width: 5px;
  height: 5px;
  top: 7px;
  right: 7px;
  background-color: white;
  border-radius: 100%;
}
.custom-progress-bar progress[value]::-moz-progress-bar {
  background-image: -moz-linear-gradient(45deg, #3b4aff 0%, #40bbff 100%);
  background-size: 100%;
  border-radius: 4px;
}
.custom-progress-bar .progress-bar {
  display: flex;
  align-items: flex-end;
  gap: 9px;
  margin-bottom: 8px;
}
.custom-progress-bar .progress-bar__bar {
  position: relative;
  width: 100%;
}
.custom-progress-bar .progress-bar__max {
  color: var(--sebrae-blue);
  font-family: var(--font-lato);
  font-size: 16px;
  font-weight: 700;
  line-height: 1;
}
.custom-progress-bar .progress-bar__max.error {
  color: var(--sebrae-red);
}
.custom-progress-bar .progress-bar p {
  min-width: 18px;
  text-align: right;
  margin-bottom: -3px;
}
.custom-progress-bar.error p {
  color: var(--sebrae-red);
}
.custom-progress-bar.error progress[value]::-webkit-progress-value {
  background-image: -webkit-linear-gradient(45deg, #F4455A 0%, #FFABAB 100%);
}
.custom-progress-bar.error progress[value]::-moz-progress-bar {
  background-image: -moz-linear-gradient(45deg, #F4455A 0%, #FFABAB 100%);
}`, "",{"version":3,"sources":["webpack://./src/components/progress-bar/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,cAAA;AACF;AACE;EACE;IACE,6BAAA;EACJ;AACF;AACE;EACE,yBAAA;EAEE,6BAAA;EACA,eAAA;EACA,gBAAA;EAEF,cAAA;EACA,eAAA;AADJ;AAGE;EACE,gBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AADJ;AAGI;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;AADN;AAGI;EACE,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,0EAAA;EACA,6CAAA;AADN;AAGM;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;AADR;AAII;EACE,uEAAA;EACA,qBAAA;EACA,kBAAA;AAFN;AAKE;EACE,aAAA;EACA,qBAAA;EACA,QAAA;EACA,kBAAA;AAHJ;AAKI;EACE,kBAAA;EACA,WAAA;AAHN;AAKI;EACE,yBAAA;EAEE,6BAAA;EACA,eAAA;EACA,gBAAA;EAEF,cAAA;AALN;AAOM;EACE,wBAAA;AALR;AAQI;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;AANN;AAWI;EACE,wBAAA;AATN;AAYM;EACE,0EAAA;AAVR;AAYM;EACE,uEAAA;AAVR","sourcesContent":[".custom-progress-bar {\n  position: relative;\n  margin: 15px 0;\n\n  @keyframes animate-stripes {\n    100% {\n      background-position: -100px 0;\n    }\n  }\n  p {\n    color: var(--sebrae-blue);\n    font: {\n      family: var(--font-lato);\n      size: 13px;\n      weight: 400;\n    }\n    line-height: 1;\n    max-width: 100%;\n  }\n  progress[value] {\n    appearance: none;\n    border: none;\n    width: 100%;\n    height: 8px;\n    background-color: #E2E6E8;\n    border-radius: 4px;\n    box-shadow: none;\n    color: var(--sebrae-blue);\n    position: relative;\n\n    &::-webkit-progress-bar {\n      background-color: #E2E6E8;\n      border-radius: 4px;\n      box-shadow: none;\n    }\n    &::-webkit-progress-value {\n      position: relative;\n      background-size: 100%;\n      border-radius: 3px;\n      background-image: -webkit-linear-gradient(45deg, #3b4aff 0%, #40bbff 100%);\n      animation: animate-stripes 5s linear infinite;\n\n      &:after {\n        content: '';\n        position: absolute;\n        width: 5px;\n        height: 5px;\n        top: 7px;\n        right: 7px;\n        background-color: white;\n        border-radius: 100%;\n      }\n    }\n    &::-moz-progress-bar {\n      background-image: -moz-linear-gradient(45deg, #3b4aff 0%, #40bbff 100%);\n      background-size: 100%;\n      border-radius: 4px;\n    }\n  }\n  .progress-bar {\n    display: flex;\n    align-items: flex-end;\n    gap: 9px;\n    margin-bottom: 8px;\n\n    &__bar {\n      position: relative;\n      width: 100%;\n    }\n    &__max {\n      color: var(--sebrae-blue);\n      font: {\n        family: var(--font-lato);\n        size: 16px;\n        weight: 700;\n      }\n      line-height: 1;\n\n      &.error {\n        color: var(--sebrae-red);\n      }\n    }\n    p {\n      min-width: 18px;\n      text-align: right;\n      margin-bottom: -3px;\n    }\n  }\n\n  &.error {\n    p {\n      color: var(--sebrae-red);\n    }\n    progress[value] {\n      &::-webkit-progress-value {\n        background-image: -webkit-linear-gradient(45deg, #F4455A 0%, #FFABAB 100%);\n      }\n      &::-moz-progress-bar {\n        background-image: -moz-linear-gradient(45deg, #F4455A 0%, #FFABAB 100%);\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
